/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var config = require('../config');
var browser = require('../../helper/browser');
var dingding = require('../../helper/dingding');

var User = function () {
    function User() {
        (0, _classCallCheck3["default"])(this, User);

        _scope.Feature.EventBus(this);
        _scope.Feature.Room(this);
        // this.user = param.name || _scope.Utils.GetCookie('user') || '匿名网友';
        // this.avatar = param.avatar || _scope.Utils.GetCookie('avatar') || 'https://mudu.tv/assets/img/avatar.png';
        // this.id = param.id || _scope.Utils.GetCookie('visitorId') || new Date().getTime() + '' + _scope.Utils.GetRandomNum(1000, 9999) + 'sdk';
        // this._SetCookie(this.user, this.avatar, this.id);

        this._listenStartSessionSuccess();
        this._listenUpdateUserInfo();
        this._msgbusDestroy();
    }

    (0, _createClass3["default"])(User, [{
        key: '_msgbusDestroy',
        value: function _msgbusDestroy() {
            var _this = this;

            this.destroyKey = _scope.MsgBus.On('Destroy', function () {
                _scope.MsgBus.UnSubAll('User.Registered');
                _scope.MsgBus.UnSubAll('User.Assigned');
                _scope.MsgBus.UnSub(_this.destroyKey);
            });
        }
    }, {
        key: '_listenUpdateUserInfo',
        value: function _listenUpdateUserInfo() {
            var _this2 = this;

            _scope.MsgBus.Sub('User.Update', function () {
                _this2._getUserInfo(function (userInfo) {
                    _this2.Room.tracker.updateProperties({
                        name: userInfo.user.nick,
                        third_id: userInfo.user.assign_id,
                        avatar: userInfo.user.avatar,
                        outer_id: userInfo.user.outer_id
                    });
                    _scope.MsgBus.Pub('User.Update.Over', userInfo);
                });
            });
        }
    }, {
        key: '_listenStartSessionSuccess',
        value: function _listenStartSessionSuccess() {
            var _this3 = this;

            _scope.MsgBus.Sub('User.StartSeesionSuccess', function (userInfo) {
                _this3._dealUserInfo(userInfo, function (userInfo) {
                    var _Room = _this3.Room,
                        actHashId = _Room.actHashId,
                        projectId = _Room.projectId;

                    _this3.Room.tracker.init(projectId, userInfo.user.id, actHashId, actHashId);
                    _this3.Room.tracker.startDataTracker({
                        name: userInfo.user.nick,
                        third_id: userInfo.user.assign_id,
                        avatar: userInfo.user.avatar,
                        outer_id: userInfo.user.outer_id,
                        phone: userInfo.user.phone
                    }, userInfo.session_id);
                    _this3._PubInitUserOver();
                });
            });
        }
    }, {
        key: '_PubInitUserOver',
        value: function _PubInitUserOver() {
            _scope.MsgBus.Pub('User.Init.Over');
        }
    }, {
        key: '_getUserInfo',
        value: function _getUserInfo(cb) {
            var _this4 = this;

            var url = config.USER_AUTH_GET_USER_INFO + this.Room.actHashId;
            Fetcher.Get(url, function (res) {
                try {
                    _this4._dealUserInfo(JSON.parse(res), cb);
                } catch (err) {
                    _scope.MsgBus.Pub('User.Init.Error', err);
                    _scope.MsgBus.Pub('Room.Init.Error', err);
                }
            });
        }
    }, {
        key: '_dealUserInfo',
        value: function _dealUserInfo() {
            var userInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var cb = arguments[1];

            if ((typeof userInfo === 'undefined' ? 'undefined' : (0, _typeof3["default"])(userInfo)) !== 'object') return;
            try {
                this.user = userInfo.user;
                this.avatar = userInfo.user.avatar;
                this.id = userInfo.user.id;

                _scope.DB.Set('UserInfo', userInfo.user);

                _scope.DB.Set('User', this);
                _scope.MsgBus.Pub('User.Assigned', this);

                typeof cb === 'function' && cb(userInfo);
            } catch (e) {
                console.warn('user info err', e); // eslint-disable-line
            }
        }

        // 身份赋予接口 对外

    }, {
        key: 'Assign',
        value: function Assign(name, avatar, assignId, cb) {
            // 避免属性undefined报错
            this._Assign({
                name: name || '',
                avatar: avatar || '',
                assignId: assignId || Date.now(),
                type: 'assign'
            }, cb);
        }

        // 身份赋予接口 对外 参数使用object

    }, {
        key: 'AssignInfo',
        value: function AssignInfo(assignUserInfo, cb) {
            this._Assign({
                name: assignUserInfo.name || '',
                avatar: assignUserInfo.avatar || '',
                assignId: assignUserInfo.assignId || Date.now(),
                phone: assignUserInfo.phone || '',
                type: 'assign'
            }, cb);
        }

        // 身份赋予接口 自用

    }, {
        key: '_Assign',
        value: function _Assign(assignUserInfo, cb) {
            if (!this.id) {
                // User 初始化 未完成
                console.warn(' fetch userinfo not completed '); // eslint-disable-line
                return;
            }

            this.Regist(assignUserInfo.name, assignUserInfo.avatar, assignUserInfo.assignId, assignUserInfo.type, cb, assignUserInfo.phone);
        }
    }, {
        key: 'Regist',
        value: function Regist(name, avatar, id) {
            var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'assign';
            var cb = arguments[4];
            var phone = arguments[5];

            var _self = this;
            var uin = this.Room.uin;

            if (!this.Room) {
                return;
            }

            // Assign前先登出匿名账号
            Fetcher.Post(config.API_DOMAIN + '/user/api/logout?act_id=' + _self.Room.actHashId, (0, _stringify2["default"])({
                session_id: _self.Room.tracker.getSessionId()
            }), function () {
                // 登出后使用assign login
                var url = config.USER_AUTH_LOGIN_BY_OTHER;
                Fetcher.Post(url, (0, _stringify2["default"])({
                    act_id: _self.Room.actHashId,
                    type: type,
                    user_id: uin + '_' + id,
                    avatar: avatar,
                    nick: name,
                    phone: phone
                }), function (data) {
                    data = JSON.parse(data);
                    var cbData = {};
                    var isSuccess = data.errcode === 1000;
                    cbData.status = isSuccess ? 'y' : 'n';
                    cbData.info = data.msg;
                    // cbData.flag = data.Flag;
                    if (isSuccess) {
                        // 重新获取 用户 信息
                        _scope.MsgBus.Pub('User.Registered', (0, _stringify2["default"])(cbData));
                        _scope.MsgBus.Pub('User.AssignLoginByOther', (0, _extends3["default"])({}, cbData, { token: data.token }));
                        var cbIsCalled = false;
                        _scope.MsgBus.Sub('User.StartSeesionSuccess', function (userInfo) {
                            _self.Room.tracker.updateProperties({
                                name: userInfo.user.nick,
                                third_id: userInfo.user.assign_id,
                                avatar: userInfo.user.avatar,
                                outer_id: userInfo.user.outer_id
                            });
                            if (cbIsCalled) {
                                return;
                            }
                            cbIsCalled = true;
                            typeof cb === 'function' && cb(userInfo);
                        });
                    }
                }, {
                    'User-Agent': navigator.userAgent,
                    'Referer': document.referrer,
                    'Content-Type': 'application/json'
                });
            }, {
                'User-Agent': navigator.userAgent,
                'Referer': document.referrer,
                'Content-Type': 'application/json'
            });
        }

        // _SetCookie(name,avatar,id) {
        //     _scope.Utils.SetCookie('user', name);
        //     _scope.Utils.SetCookie('avatar', avatar);
        //     _scope.Utils.SetCookie('visitorId', id);
        //     _scope.MsgBus.Pub('User.Assigned', this);
        //     _scope.DB.Set('User', this);
        // }

    }, {
        key: 'GetUser',
        value: function GetUser() {
            var UserInfo = _scope.DB.Get('UserInfo');
            return {
                name: UserInfo.nick,
                avatar: UserInfo.avatar,
                phone: UserInfo.phone,
                id: UserInfo.id,
                assign_id: UserInfo.assign_id,
                hash_id: UserInfo.hash_id,
                outer_id: UserInfo.outer_id
            };
        }
    }, {
        key: 'SocialLogin',
        value: function SocialLogin(loginType) {
            var socialAuthConfig = _scope.DB.Get('socialAuthConfig');
            if (!socialAuthConfig) return;
            var _socialAuthConfig$isS = socialAuthConfig.isSetType,
                issetQq = _socialAuthConfig$isS.issetQq,
                issetWeibo = _socialAuthConfig$isS.issetWeibo,
                _socialAuthConfig$oau = socialAuthConfig.oauth2AppIdConfig,
                qq_appid = _socialAuthConfig$oau.qq_appid,
                weibo_appid = _socialAuthConfig$oau.weibo_appid,
                weixin_mp_appid = _socialAuthConfig$oau.weixin_mp_appid;

            var _scope$DB$Get = _scope.DB.Get('UserInfo'),
                wx_union_id = _scope$DB$Get.wx_union_id,
                qq_open_id = _scope$DB$Get.qq_open_id,
                wb_open_id = _scope$DB$Get.wb_open_id;

            loginType = _scope.Utils.GetPrimarySocialLoginType(loginType);

            // 已经授权过的情况
            if (loginType == 'weixin' && wx_union_id) {
                return;
            } else if (loginType == 'qq' && qq_open_id) {
                return;
            } else if (loginType == 'weibo' && wb_open_id) {
                return;
            }

            var appid = '';
            if (loginType == 'weixin') {
                appid = weixin_mp_appid;
            } else if (loginType == 'qq' && issetQq) {
                appid = qq_appid;
            } else if (loginType == 'weibo' && issetWeibo) {
                appid = weibo_appid;
            }

            var referer = encodeURIComponent(window.location.href);
            var url = config.AUTH_DOMAIN + '/user/api/sociallogin/' + loginType + '/' + appid + '?referer=' + referer;
            window.location.href = url;
        }
    }, {
        key: 'WechatLogin',
        value: function WechatLogin() {
            var relogin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (_scope.DB.Get('UserInfo').wx_union_id && !relogin) {
                return false;
            }

            if (!browser.isWechat()) {
                return false;
            }

            var referer = encodeURIComponent(window.location.href);
            var url = this.Room.domain + config.RELATIVE_SOCIAL_LOGIN_URL + '&loginType=weixin&referer=' + referer;
            window.location.href = url;
        }
    }, {
        key: 'IsWechatLogined',
        value: function IsWechatLogined() {
            return browser.isWechat() && !!_scope.DB.Get('UserInfo').wx_union_id;
        }
    }, {
        key: 'DingdingLogin',
        value: function DingdingLogin() {
            var _this5 = this;

            if (!this.Room.dingdingIsvConfig) {
                return false;
            }
            if (_scope.DB.Get('UserInfo').dingding_open_id) {
                // 用户 是否 已经 钉钉 授权 过
                return false;
            }
            if (!browser.isDingding()) {
                return false;
            }
            if (typeof dd === 'undefined') {
                return false;
            }
            dingding.init(this.Room.dingdingIsvConfig, function () {
                return dingding.login(_this5.Room.dingdingIsvConfig.corpId, function (_ref) {
                    var id = _ref.id,
                        user = _ref.user,
                        avatar = _ref.avatar;

                    _this5._Assign(user, avatar, id, 'dingding');
                });
            });
        }
    }]);
    return User;
}();

module.exports = User;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/core/User.js
 ** module id = 147
 ** module chunks = 1
 **/